// import React from 'react';
// import axios from 'axios';
// import { JobDetails, JobListing } from '@components/local/jobs-board';

// import { JOB_BOARD_COMPILER_BASE_URL } from '@lib/api';
// import { extractHexCode } from '@utils/helper';

// function Jobs({
//   jobs = [],
//   filterOptions,
//   filtersBasedOnParams = {},
//   isJobDetailPage,
//   jobDetails,
//   title,
// }) {
//   return (
//     <>
//       {isJobDetailPage ? (
//         <JobDetails JobData={jobDetails} />
//       ) : (
//         <JobListing
//           jobs={jobs}
//           filterOptions={filterOptions}
//           filtersBasedOnParams={filtersBasedOnParams}
//           fetchJobsData={fetchJobsData}
//           title={title}
//         />
//       )}
//     </>
//   );
// }

// export default Jobs;

// export async function getServerSideProps({ req, res, params }) {
//   const origin = req?.headers.host?.startsWith('local')
//     ? `http://${req?.headers.host}`
//     : `https://${req?.headers.host}`;

//   const jobParam = params?.jobs?.[0];

//   try {
//     const { isJDParam, value } = checkIsJDParam(jobParam);

//     if (isJDParam) {
//       const {
//         data: { jobDescription },
//       } = await axios.get(
//         `${JOB_BOARD_COMPILER_BASE_URL}/api/ab/job-board/fetch/by-job-id?jobId=${value}`,
//         { headers: { origin } }
//       );

//       if (!jobDescription) {
//         return {
//           notFound: true,
//         };
//       }

//       res.setHeader('Cache-Control', 'public, s-maxage=3600, stale-while-revalidate');

//       return {
//         props: {
//           jobs: [],
//           filterOptions: {},
//           filtersBasedOnParams: {},
//           isJobDetailPage: isJDParam,
//           jobDetails: jobDescription,
//         },
//       };
//     }

//     const { data: filterOptions } = await axios.get(
//       `${JOB_BOARD_COMPILER_BASE_URL}/api/ab/job-board/filter-params`,
//       { headers: { origin } }
//     );

//     const dynamicFilter = createDynamicFilterByParam(jobParam, filterOptions);

//     const jobs = await fetchJobsData(origin, dynamicFilter);

//     const title = createDynamicTitle(dynamicFilter);

//     res.setHeader('Cache-Control', 'public, s-maxage=1800, stale-while-revalidate');

//     return {
//       props: { jobs, filterOptions, filtersBasedOnParams: dynamicFilter, title },
//     };
//   } catch (error) {
//     console.error(error);
//     return {
//       notFound: true,
//     };
//   }
// }

// async function fetchJobsData(origin = '', filters = null) {
//   const {
//     data: { data: jobs },
//   } = await axios.post(
//     `${JOB_BOARD_COMPILER_BASE_URL}/api/ab/job-board/fetch`,
//     {
//       pagination: {
//         start: 0,
//         end: 100,
//       },
//       ...(filters ? { queryParams: filters } : {}),
//     },
//     origin ? { headers: { origin } } : {}
//   );

//   return jobs;
// }

// function createDynamicFilterByParam(param = '', filterOptions = {}) {
//   if (!param.includes('-')) {
//     return {};
//   }

//   const paramsArray = param.trim().split('-');

//   const restWord = [];

//   const filter = paramsArray.reduce(
//     (accu, param) => {
//       const formattedParam = CapitalEachWord(param);

//       if (formattedParam === 'Jobs') {
//         return accu;
//       }

//       const matchedLocation = findDataByCriteria(formattedParam, filterOptions?.locations);

//       const matchedCompany = findDataByCriteria(formattedParam, filterOptions?.companies);

//       const isJobLocation = filterOptions?.jobLocations?.includes(formattedParam);

//       const isEmploymentType = filterOptions?.employmentTypes?.includes(formattedParam);

//       switch (true) {
//         case isJobLocation:
//           accu['jobLocation'] = formattedParam;
//           break;

//         case isEmploymentType:
//           accu['employmentType'] = formattedParam;
//           break;

//         case !!matchedCompany:
//           accu['companies'].push(matchedCompany);
//           break;

//         case !!matchedLocation:
//           accu['location'].push(matchedLocation);
//           break;

//         default:
//           restWord.push(formattedParam);
//           break;
//       }

//       return accu;
//     },
//     { location: [], companies: [], role: '' }
//   );

//   filter.companies = [...new Set(filter.companies)];
//   filter.location = [...new Set(filter.location)];

//   // const joinedParam = restWord.join(" ")
//   const copyRestWord = [...restWord];

//   let matchedDomain;

//   if (restWord.length >= 2) {
//     const domainKeyword = copyRestWord.splice(0, 2).join(' ');

//     matchedDomain = filterOptions?.domains?.find((domain = '') => domain === domainKeyword);
//   }

//   matchedDomain ? (filter['domain'] = matchedDomain) : (filter['role'] = restWord.join(' ').trim());

//   if (matchedDomain && copyRestWord.length > 0) {
//     filter['role'] = copyRestWord.join(' ');
//   }

//   return filter;
// }

// function CapitalEachWord(str = '') {
//   return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
// }

// function findDataByCriteria(keyword, options = []) {
//   return options.find((key) => new RegExp(`\\b${keyword}\\b`, 'i').test(key));
// }

// function checkIsJDParam(param = '') {
//   if (!param || !param?.includes('job-')) {
//     return { isJDParam: false, value: '' };
//   }

//   const inputString = param?.split('job-')?.[1];

//   const extractedHexCodes = extractHexCode(inputString) || [];

//   const extractedValue = extractedHexCodes.pop();

//   const value = extractedValue.includes('-') && extractedValue.length > 10 ? extractedValue : '';

//   return { isJDParam: !!value, value };
// }

// function createDynamicTitle(filters = {}) {
//   let title = '';

//   if (Object.keys(filters).length === 0) {
//     return title;
//   }

//   const { domain, jobLocation, role, employmentType, companies = [], location = [] } = filters;

//   if (domain) {
//     title += `${domain} `;
//   }

//   if (jobLocation) {
//     title += `${jobLocation} `;
//   }

//   if (role) {
//     title += `${role} `;
//   }

//   if (employmentType && employmentType === 'Internship') {
//     title += `${employmentType} `;
//   } else {
//     title += `${employmentType ? employmentType : ''} Jobs `;
//   }

//   if (companies?.length > 0) {
//     title += `in ${companies[0]} `;
//   }

//   if (location?.length > 0) {
//     const city = location[0]?.split(',')[0];

//     if (title.includes(' in ')) {
//       title += `${city}`;
//     } else {
//       title += `in ${city}`;
//     }
//   }

//   return title;
// }
import React from 'react';

const Jobs = () => {
  return <div></div>;
};

export default Jobs;
